import { CircleApi } from 'api/CirclesApi';
import { backendApiClient } from 'container/backendApiClient';

export const circleApi = new CircleApi(backendApiClient);
